import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import {store,persistor} from 'stateManagement/stores/store';
// import GeneralState from 'contexts/intranet/general/GeneralState'
{/* <script type="text/javascript">
  function test(){
    alert('Function from index.html')
  }
</script> */}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {/* <GeneralState> */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
      {/* </GeneralState> */}
    </PersistGate>
  </Provider>
  , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
